document.addEventListener("DOMContentLoaded", function() {
    const quickAddButton = document.querySelector('.quick-add');
  
    // Stop propagation on mobile tap
    quickAddButton.addEventListener('touchend', function(event) {
      event.stopPropagation();
    }, false);
  });